export default function Card({ className, children }) {
  return (
    <div
      className={
        "bg-white-100 rounded border border-white-200 shadow-card p-5 " +
        className
      }
    >
      {children}
    </div>
  );
}
